import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline' // Neutral warning icon
import { Box, Button, Typography } from '@mui/material'

const AxleExitStatus = ({ onStartSession }: { onStartSession: () => void }): JSX.Element => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 2,
        boxShadow: 3,
        p: 3,
        mx: 'auto',
        mt: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
      }}
    >
      {/* Warning Icon */}
      <ErrorOutlineIcon sx={{ fontSize: 50, color: 'warning.main', mb: 2 }} />

      {/* Message to the User */}
      <Typography variant="h6" sx={{ color: 'text.primary', mb: 2 }}>
        You have exited the connector
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
        No account was connected. To proceed, please start a new session.
      </Typography>

      {/* Button to Start a New Session */}
      <Button
        variant="contained"
        color="primary"
        onClick={onStartSession}
        sx={{ fontWeight: 'bold' }}
      >
        Start New Session
      </Button>
    </Box>
  )
}

export default AxleExitStatus
